import { render, staticRenderFns } from "./DotDotDot.vue?vue&type=template&id=4ee3edb8&"
import script from "./DotDotDot.vue?vue&type=script&lang=js&"
export * from "./DotDotDot.vue?vue&type=script&lang=js&"
import style0 from "./DotDotDot.vue?vue&type=style&index=0&id=4ee3edb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports